import { useMemo } from "react";
import wretch, { WretchOptions, WretchResponse } from "wretch";
import { useParams } from "react-router";
import AbortAddon from "wretch/addons/abort";
import QueryStringAddon from "wretch/addons/queryString";

import { ApiClient, createApiClient } from "../api-client";
import { AuthService } from "../auth";

export function useEmsApi(): ApiClient {
  // use orgaId from routing params
  const { orgaId } = useParams();

  return useMemo(() => {
    return createApiClient(AuthService.getTokenSilently, orgaId);
  }, [orgaId]);
}

function auth(getAccessTokenSilently: (options?: any) => Promise<any>) {
  return function (next: (url: string, opts: WretchOptions) => Promise<WretchResponse>) {
    return async function (url: string, opts: WretchOptions) {
      const accessToken = await getAccessTokenSilently();
      return Promise.resolve(
        next(url, {
          ...opts,
          headers: {
            ...opts.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      );
    };
  };
}

export const Middlewares = {
  auth: auth,
};

export function makeWretchInstance(getAccessTokenSilently: (options: any) => Promise<any>) {
  return wretch("/api")
    .middlewares([Middlewares.auth(getAccessTokenSilently)])
    .addon(AbortAddon())
    .addon(QueryStringAddon)
    .resolve((r) => r.res());
}
